import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3517_4",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_3517_4)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.95 20.65L18.1 19.5L16.5 17.9L15.35 19.05C15.1167 19.2833 15 19.55 15 19.85C15 20.15 15.1167 20.4167 15.35 20.65C15.5833 20.8833 15.85 21 16.15 21C16.45 21 16.7167 20.8833 16.95 20.65ZM19.5 18.1L20.65 16.95C20.8833 16.7167 21 16.45 21 16.15C21 15.85 20.8833 15.5833 20.65 15.35C20.4167 15.1167 20.15 15 19.85 15C19.55 15 19.2833 15.1167 19.05 15.35L17.9 16.5L19.5 18.1ZM18.375 22.075C17.7583 22.6917 17.0167 23 16.15 23C15.2833 23 14.5417 22.6917 13.925 22.075C13.3083 21.4583 13 20.7167 13 19.85C13 18.9833 13.3083 18.2417 13.925 17.625L17.625 13.925C18.2417 13.3083 18.9833 13 19.85 13C20.7167 13 21.4583 13.3083 22.075 13.925C22.6917 14.5417 23 15.2833 23 16.15C23 17.0167 22.6917 17.7583 22.075 18.375L18.375 22.075ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.2C9.41667 2.4 9.77917 1.91667 10.2875 1.55C10.7958 1.18333 11.3667 1 12 1C12.6333 1 13.2042 1.18333 13.7125 1.55C14.2208 1.91667 14.5833 2.4 14.8 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V11.125C20.6667 11.0417 20.3333 11 20 11C19.6667 11 19.3333 11.025 19 11.075V5H5V19H11.075C11.025 19.3333 11 19.6667 11 20C11 20.3333 11.0417 20.6667 11.125 21H5ZM12.5375 4.0375C12.6792 3.89583 12.75 3.71667 12.75 3.5C12.75 3.28333 12.6792 3.10417 12.5375 2.9625C12.3958 2.82083 12.2167 2.75 12 2.75C11.7833 2.75 11.6042 2.82083 11.4625 2.9625C11.3208 3.10417 11.25 3.28333 11.25 3.5C11.25 3.71667 11.3208 3.89583 11.4625 4.0375C11.6042 4.17917 11.7833 4.25 12 4.25C12.2167 4.25 12.3958 4.17917 12.5375 4.0375ZM7 9V7H17V9H7ZM7 13V11H17V11.85C16.8667 11.9333 16.7375 12.0292 16.6125 12.1375C16.4875 12.2458 16.3583 12.3667 16.225 12.5L15.725 13H7ZM7 17V15H13.725L12.5 16.225C12.3667 16.3583 12.2458 16.4875 12.1375 16.6125C12.0292 16.7375 11.9333 16.8667 11.85 17H7Z",
			fill: "currentColor"
		})
	})]
});
export default SvgClipboard;
